import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface ICountDownField {
	changeCountDown: (value: string) => void;
}

const CountDownField: React.FC<ICountDownField> = ({ changeCountDown }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterCountdown') }], [t]);

	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const onlyDigits = e.target.value.replace(/\D/g, '');
			changeCountDown(onlyDigits);
			return onlyDigits;
		},
		[changeCountDown],
	);

	return (
		<FormInput
			testId="CountDownField"
			name="countDown"
			label="countdownLabel"
			getValueFromEvent={handleChange}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(CountDownField);
